import { render, staticRenderFns } from "./CailiaotongzhidanTable.vue?vue&type=template&id=cb535d8e&"
import script from "./CailiaotongzhidanTable.vue?vue&type=script&lang=js&"
export * from "./CailiaotongzhidanTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports